'use client'

import React from 'react'
import { useTranslation } from 'react-i18next'
import { InkHero } from '@/components/site/ink-hero'

export function HomeHero() {
  const { t } = useTranslation(['web'])
  return (
    <InkHero
      eyebrow={t('web:homePage.hero.eyebrow')}
      titleKey="web:homePage.hero.title"
      lead={t('web:homePage.hero.lead')}
      copyWidth="narrow"
      titleSize="compact"
      inkPlacement="short"
    />
  )
}
